"use strict";

var _typeof2 = require("@babel/runtime/helpers/typeof");
function _typeof(e) {
  return (_typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (e) {
    return _typeof2(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof2(e);
  })(e);
}
function _classCallCheck(e, o) {
  if (!(e instanceof o)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, o) {
  for (var t = 0; t < o.length; t++) {
    var r = o[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, _toPropertyKey(r.key), r);
  }
}
function _createClass(e, o, t) {
  return o && _defineProperties(e.prototype, o), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(e) {
  e = _toPrimitive(e, "string");
  return "symbol" == _typeof(e) ? e : e + "";
}
function _toPrimitive(e, o) {
  if ("object" != _typeof(e) || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (void 0 === t) return ("string" === o ? String : Number)(e);
  o = t.call(e, o || "default");
  if ("object" != _typeof(o)) return o;
  throw new TypeError("@@toPrimitive must return a primitive value.");
}
var geocoder, autocompleteService;
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;
var GeocoderService = exports["default"] = function () {
  return _createClass(function e() {
    _classCallCheck(this, e);
  }, null, [{
    key: "geocoder",
    get: function get() {
      if ("undefined" == typeof google) throw new Error("google service has not been included and is required for this component to operate");
      return geocoder = geocoder || new window.google.maps.Geocoder();
    }
  }, {
    key: "autocompleteService",
    get: function get() {
      if ("undefined" == typeof google) throw new Error("google service has not been included and is required for this component to operate");
      return autocompleteService = autocompleteService || new window.google.maps.places.AutocompleteService();
    }
  }, {
    key: "promiseGeocode",
    value: function value(n) {
      var e = this;
      return new Promise(function (t, r) {
        e.geocoder.geocode({
          address: n
        }, function (e, o) {
          return o === window.google.maps.GeocoderStatus.OK ? t({
            address: n,
            lat: e[0].geometry.location.lat(),
            lng: e[0].geometry.location.lng(),
            types: e[0].types
          }) : r(new Error("No geocoding results for: ".concat(n)));
        });
      });
    }
  }, {
    key: "promiseReverseGeocode",
    value: function value(e) {
      var o = this;
      return new Promise(function (t, r) {
        o.geocoder.geocode({
          location: {
            lat: e.lat,
            lng: e.lng
          }
        }, function (e, o) {
          return o === window.google.maps.GeocoderStatus.OK ? t({
            address: e[0].geometry.location.formatted_address(),
            lat: e[0].geometry.location.lat(),
            lng: e[0].geometry.location.lng()
          }) : r(e);
        });
      });
    }
  }]);
}();